import { string, object } from "yup";

export default object().shape({
  company_name: string()
    .nullable()
    .required("Please enter a company name")
});
